module.exports = __webpack_public_path__ + "static/52gde-cdd17f64851753b2ca56c35d308e2419.gif";